import React from "react";
import "./createSuccessfulTimetable.css";

const StudyPlannerMultiple = ({ close }) => {
  return (
    <>
      <div className=" successful_create_transprant_body">
        <div className=" p-2 successful_create_container shadow">
          <img src="images/alert.svg" alt="" />
          <span className=" my-4 successfully_create_message">
            You have overlapping time for StudyPlanner Lecture.
          </span>
          <button className="btn btn-danger px-4 py-2 successfull_create_okay_btn" onClick={() => { close(false) }}>
            Okay
          </button>
        </div>
      </div>
    </>
  );
};

export default StudyPlannerMultiple;
